import * as types from './mutation-types'

export default {
  [types.ADD_BUNDLES](state, data) {
    state.bundles = data
  },

  [types.ADD_BUNDLE](state, data) {
    state.bundles.push(data)
  },

  [types.SET_IMAGE_BUNDLE] (state, {id, image}) {
    state.bundle = state.bundles.map((bundle) => { if (bundle.id == id) {bundle.file = image} return bundle })
  },

  [types.LOAD_APPLIES](state, data) {
    state.applies = data
  },

  [types.LOAD_TYPES](state, data) {
    state.types = data
  },
}